// extracted by mini-css-extract-plugin
export default {"delimiter":"hybrid-block-module__delimiter--dRltz","activeBlock":"hybrid-block-module__activeBlock--NdH9i"};